<template>
  <div class="top-bar-msg">
    <div class="settings-wrapper">
      <div class="tab-wrapper tab-wrapper-messages">
        <router-link
          id="messages_mobile_tab"
          :to="{ name: 'Messages tagging main tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.9982 2.25C10.3149 2.24963 8.66018 2.68508 7.19508 3.51396C5.72999 4.34285 4.50445 5.53692 3.63776 6.97997C2.77106 8.42301 2.29274 10.0659 2.24934 11.7486C2.20594 13.4314 2.59894 15.0967 3.3901 16.5825L2.32603 19.7747C2.2379 20.039 2.2251 20.3226 2.28909 20.5938C2.35309 20.8649 2.49133 21.1129 2.68833 21.3099C2.88534 21.5069 3.13331 21.6451 3.40447 21.7091C3.67562 21.7731 3.95924 21.7603 4.22353 21.6722L7.41572 20.6081C8.72332 21.3036 10.1722 21.6921 11.6523 21.744C13.1324 21.7959 14.605 21.51 15.9581 20.9079C17.3112 20.3057 18.5094 19.4033 19.4617 18.269C20.4139 17.1346 21.0953 15.7983 21.454 14.3613C21.8127 12.9244 21.8393 11.4246 21.5318 9.97578C21.2243 8.52701 20.5908 7.16732 19.6794 5.99992C18.7679 4.83253 17.6025 3.88811 16.2716 3.23836C14.9407 2.58861 13.4793 2.25061 11.9982 2.25ZM11.9982 20.25C10.5479 20.251 9.123 19.8691 7.8676 19.1428C7.77568 19.0895 7.67349 19.0563 7.56778 19.0455C7.46208 19.0347 7.35529 19.0464 7.25447 19.08L3.74822 20.25L4.91728 16.7438C4.95098 16.643 4.96289 16.5362 4.95223 16.4305C4.94156 16.3248 4.90856 16.2226 4.85541 16.1306C3.94601 14.5584 3.58089 12.7299 3.81669 10.929C4.05249 9.12801 4.87603 7.4552 6.15955 6.17006C7.44308 4.88491 9.11484 4.05925 10.9155 3.82118C12.7162 3.5831 14.5451 3.94591 16.1185 4.85333C17.6919 5.76074 18.9219 7.16204 19.6176 8.83983C20.3134 10.5176 20.436 12.3781 19.9664 14.1327C19.4969 15.8873 18.4615 17.4379 17.0207 18.5439C15.58 19.65 13.8145 20.2497 11.9982 20.25Z"
              fill="#696F79"
            />
          </svg>
          <span class="tab-btn-msg-text">Messages</span>
        </router-link>
        <router-link
          id="messages_email_tab"
          :to="{ name: 'Messages tagging tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.8103 12.75L13.5 3.43969C13.3612 3.2998 13.196 3.18889 13.014 3.11341C12.832 3.03792 12.6368 2.99938 12.4397 3.00001H3.75001C3.5511 3.00001 3.36033 3.07903 3.21968 3.21968C3.07903 3.36033 3.00001 3.5511 3.00001 3.75001V12.4397C2.99938 12.6368 3.03792 12.832 3.11341 13.014C3.18889 13.196 3.2998 13.3612 3.43969 13.5L12.75 22.8103C12.8893 22.9496 13.0547 23.0602 13.2367 23.1356C13.4187 23.211 13.6138 23.2498 13.8108 23.2498C14.0078 23.2498 14.2029 23.211 14.3849 23.1356C14.5669 23.0602 14.7323 22.9496 14.8716 22.8103L22.8103 14.8716C22.9496 14.7323 23.0602 14.5669 23.1356 14.3849C23.211 14.2029 23.2498 14.0078 23.2498 13.8108C23.2498 13.6138 23.211 13.4187 23.1356 13.2367C23.0602 13.0547 22.9496 12.8893 22.8103 12.75ZM13.8103 21.75L4.50001 12.4397V4.50001H12.4397L21.75 13.8103L13.8103 21.75ZM9.00001 7.87501C9.00001 8.09751 8.93403 8.31502 8.81041 8.50002C8.68679 8.68503 8.51109 8.82922 8.30553 8.91437C8.09996 8.99952 7.87376 9.0218 7.65553 8.97839C7.4373 8.93498 7.23685 8.82784 7.07951 8.6705C6.92218 8.51317 6.81503 8.31271 6.77162 8.09448C6.72822 7.87626 6.75049 7.65006 6.83564 7.44449C6.92079 7.23892 7.06499 7.06322 7.24999 6.9396C7.435 6.81599 7.6525 6.75001 7.87501 6.75001C8.17338 6.75001 8.45952 6.86853 8.6705 7.07951C8.88148 7.29049 9.00001 7.57664 9.00001 7.87501Z"
              fill="#696F79"
            />
          </svg>
          <span class="tab-btn-msg-text">Tags</span>
        </router-link>
        <router-link
          id="messages_media_tab"
          :to="{ name: 'Messages tagging comments tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.25 9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61032 8.32902 8.80109 8.25 9 8.25H15C15.1989 8.25 15.3897 8.32902 15.5303 8.46967C15.671 8.61032 15.75 8.80109 15.75 9C15.75 9.19891 15.671 9.38968 15.5303 9.53033C15.3897 9.67098 15.1989 9.75 15 9.75H9C8.80109 9.75 8.61032 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9ZM9 12.75H15C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12C15.75 11.8011 15.671 11.6103 15.5303 11.4697C15.3897 11.329 15.1989 11.25 15 11.25H9C8.80109 11.25 8.61032 11.329 8.46967 11.4697C8.32902 11.6103 8.25 11.8011 8.25 12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM12 14.25H9C8.80109 14.25 8.61032 14.329 8.46967 14.4697C8.32902 14.6103 8.25 14.8011 8.25 15C8.25 15.1989 8.32902 15.3897 8.46967 15.5303C8.61032 15.671 8.80109 15.75 9 15.75H12C12.1989 15.75 12.3897 15.671 12.5303 15.5303C12.671 15.3897 12.75 15.1989 12.75 15C12.75 14.8011 12.671 14.6103 12.5303 14.4697C12.3897 14.329 12.1989 14.25 12 14.25ZM21 4.5V14.6897C21.0006 14.8867 20.9621 15.082 20.8866 15.264C20.8111 15.446 20.7002 15.6112 20.5603 15.75L15.75 20.5603C15.6112 20.7002 15.446 20.8111 15.264 20.8866C15.082 20.9621 14.8867 21.0006 14.6897 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934C20.842 3.72064 21 4.10218 21 4.5ZM4.5 19.5H14.25V15C14.25 14.8011 14.329 14.6103 14.4697 14.4697C14.6103 14.329 14.8011 14.25 15 14.25H19.5V4.5H4.5V19.5ZM15.75 15.75V18.4406L18.4397 15.75H15.75Z"
              fill="#696F79"
            />
          </svg>
          <span class="tab-btn-msg-text">Comments</span>
        </router-link>
        <router-link
          id="messages_apps_tab"
          :to="{ name: 'Messages tagging reminders tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.6075 7.56517V11.5814L16.0007 13.5835C16.1716 13.6845 16.2947 13.8481 16.343 14.0383C16.3913 14.2286 16.3607 14.4299 16.2581 14.598C16.1554 14.7661 15.9891 14.8872 15.7957 14.9347C15.6022 14.9821 15.3975 14.9521 15.2266 14.8511L11.4689 12.6338C11.3577 12.568 11.2657 12.4751 11.2018 12.3641C11.1379 12.253 11.1044 12.1276 11.1044 12V7.56517C11.1044 7.36915 11.1836 7.18115 11.3245 7.04253C11.4655 6.90392 11.6566 6.82605 11.8559 6.82605C12.0553 6.82605 12.2464 6.90392 12.3874 7.04253C12.5283 7.18115 12.6075 7.36915 12.6075 7.56517ZM11.8559 3.1304C10.6704 3.12749 9.49602 3.35586 8.4008 3.80229C7.30558 4.24872 6.31125 4.90434 5.47538 5.73121C4.79242 6.41121 4.18555 7.06534 3.58902 7.74996V6.08692C3.58902 5.89089 3.50984 5.70289 3.36889 5.56427C3.22795 5.42566 3.0368 5.34779 2.83748 5.34779C2.63816 5.34779 2.447 5.42566 2.30606 5.56427C2.16512 5.70289 2.08594 5.89089 2.08594 6.08692V9.78256C2.08594 9.97859 2.16512 10.1666 2.30606 10.3052C2.447 10.4438 2.63816 10.5217 2.83748 10.5217H6.59517C6.79449 10.5217 6.98565 10.4438 7.12659 10.3052C7.26753 10.1666 7.34671 9.97859 7.34671 9.78256C7.34671 9.58653 7.26753 9.39853 7.12659 9.25992C6.98565 9.12131 6.79449 9.04343 6.59517 9.04343H4.4345C5.10618 8.2655 5.77505 7.53284 6.53787 6.77338C7.58237 5.74613 8.91151 5.04438 10.3592 4.75582C11.8069 4.46725 13.309 4.60466 14.6778 5.15089C16.0465 5.69711 17.2213 6.62793 18.0552 7.82702C18.8891 9.02611 19.3453 10.4403 19.3666 11.8929C19.388 13.3455 18.9736 14.7721 18.1753 15.9944C17.377 17.2167 16.2301 18.1806 14.878 18.7655C13.5259 19.3505 12.0285 19.5305 10.5729 19.2833C9.11732 19.036 7.76809 18.3724 6.69381 17.3753C6.62201 17.3085 6.53755 17.2564 6.44525 17.2217C6.35295 17.1871 6.25462 17.1707 6.15587 17.1734C6.05712 17.1762 5.95989 17.198 5.86973 17.2377C5.77956 17.2774 5.69824 17.3342 5.63038 17.4048C5.56253 17.4754 5.50949 17.5585 5.47428 17.6493C5.43907 17.7401 5.42238 17.8368 5.42517 17.9339C5.42796 18.031 5.45018 18.1266 5.49055 18.2153C5.53091 18.304 5.58865 18.384 5.66044 18.4507C6.73087 19.4442 8.03226 20.1649 9.45102 20.5499C10.8698 20.935 12.3628 20.9727 13.7998 20.6597C15.2368 20.3468 16.5741 19.6927 17.6949 18.7546C18.8158 17.8165 19.6862 16.6228 20.2301 15.2778C20.774 13.9328 20.975 12.4773 20.8154 11.0383C20.6558 9.59937 20.1406 8.22068 19.3146 7.02259C18.4887 5.8245 17.3772 4.84342 16.0771 4.16498C14.7769 3.48653 13.3277 3.13134 11.8559 3.1304Z"
              fill="#696F79"
            />
          </svg>
          <span class="tab-btn-msg-text">Reminders {{
            (countReminders && countReminders > 0) ? ('(' + countReminders + ')') : ''
          }}</span>
        </router-link>
        <router-link
          id="messages_contacts_tab"
          :to="{ name: 'Messages tagging highlight tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            class="highlight"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_19997_121287)">
              <path
                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                stroke="#696F79"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.75 13.5V9L14.25 6.75V13.5"
                stroke="#696F79"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
              <path
                d="M15.75 20.1844V14.25C15.75 14.0511 15.671 13.8603 15.5303 13.7197C15.3897 13.579 15.1989 13.5 15 13.5H9C8.80109 13.5 8.61032 13.579 8.46967 13.7197C8.32902 13.8603 8.25 14.0511 8.25 14.25V20.1844"
                stroke="#696F79"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </g>
            <defs>
              <clipPath id="clip0_19997_121287">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="tab-btn-msg-text">Highlights</span>
        </router-link>
        <router-link
          id="messages_apps_tab"
          :to="{ name: 'Messages tagging pinned tab' }"
          tag="button"
          exact-path
          class="tab-btn-msg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.4948 8.37733L15.6237 3.50664C15.5045 3.38735 15.3629 3.29272 15.2071 3.22816C15.0513 3.1636 14.8843 3.13037 14.7156 3.13037C14.5469 3.13037 14.3799 3.1636 14.2241 3.22816C14.0683 3.29272 13.9267 3.38735 13.8074 3.50664L9.50302 7.82508C8.64743 7.55698 6.69387 7.2335 4.65524 8.87981C4.51472 8.99281 4.39957 9.13414 4.31729 9.29459C4.23501 9.45505 4.18743 9.63104 4.17767 9.8111C4.1679 9.99116 4.19616 10.1713 4.2606 10.3397C4.32505 10.5081 4.42423 10.6611 4.5517 10.7886L8.42993 14.6656L5.00598 18.0874C4.8855 18.2079 4.81781 18.3713 4.81781 18.5417C4.81781 18.7121 4.8855 18.8756 5.00598 18.996C5.12646 19.1165 5.28987 19.1842 5.46026 19.1842C5.63065 19.1842 5.79405 19.1165 5.91454 18.996L9.33608 15.5718L13.2119 19.448C13.331 19.5676 13.4726 19.6626 13.6285 19.7275C13.7844 19.7924 13.9516 19.8258 14.1205 19.826C14.1509 19.826 14.1806 19.826 14.2111 19.826C14.3942 19.8133 14.5724 19.7614 14.7336 19.6737C14.8948 19.5861 15.0352 19.4647 15.1454 19.3179C16.7217 17.2229 16.57 15.5196 16.204 14.5018L20.4956 10.1938C20.6148 10.0745 20.7094 9.93285 20.7739 9.77699C20.8384 9.62112 20.8715 9.45408 20.8714 9.2854C20.8714 9.11672 20.8381 8.9497 20.7734 8.7939C20.7088 8.63809 20.6141 8.49654 20.4948 8.37733ZM19.5862 9.28597L14.9897 13.8982C14.8948 13.9935 14.8321 14.1162 14.8107 14.249C14.7892 14.3818 14.81 14.5179 14.8701 14.6383C15.6294 16.1578 14.7256 17.7358 14.1205 18.5409L5.46026 9.87915C6.42981 9.09734 7.35764 8.89105 8.06714 8.89105C8.51735 8.8849 8.96384 8.97322 9.37781 9.15031C9.49858 9.21076 9.63534 9.23159 9.76863 9.20983C9.90191 9.18807 10.0249 9.12483 10.1202 9.02911L14.716 4.41447L19.5862 9.28516V9.28597Z"
              fill="#696F79"
            />
          </svg>
          <span class="tab-btn-msg-text">Priorities</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import messagesTagging from '@/mixins/messagesTagging';

export default {
  name: 'MessagesTaggingNavigationPanel',
  mixins: [messagesTagging],
  mounted() {
    if (this.$route.path.includes('chats')) {
      this.countActiveRemindersByChatId();
    }
  },
};
</script>

<style scoped>
.tab-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-width: 310px;
  width: auto;
  min-height: 35px;
  margin-right: 20px;
  border-radius: 79px;
  border: 1px solid var(--case-btn-border-color);
}

.top-bar-msg {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  background: #FFFFFF;
  box-shadow: none;
  max-width: 770px;
  width: 100%;
}

.tab-btn-msg-text {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-text-color);
  transition: 0.3s all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab-btn-msg.active .tab-btn-msg-text,
.tab-btn-msg:hover .tab-btn-msg-text {
  color: var(--secondary-black-color);
}

.tab-btn-msg.active svg path,
.tab-btn-msg:hover svg path,
.tab-btn-msg.active .highlight g > :not(:first-child),
.tab-btn-msg:hover .highlight g > :not(:first-child) {
  fill: var(--secondary-black-color);
}

.tab-btn-msg.active .highlight path,
.tab-btn-msg:hover .highlight path {
  fill: var(--white-color);
}

.settings-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings-wrapper {
  padding-bottom: 28px;
}

.tab-btn-msg {
  width: 50%;
  max-height: 35px;
  padding: 10px 30px 10px 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s all;
  gap: 5px;
}

.tab-wrapper-messages {
  border: none;
}
</style>
